import { Conta } from "./conta";
import { Pagination } from "./pagination";
import { TransferReceivable } from "./transferReceivable.model";

export class SearchResult {
  pagination: Pagination;
  vendedores: any[];
  transfers?: any;
  transferReceivables: TransferReceivable[];
  conta: Conta[];
}
